import { render, staticRenderFns } from "./QuotationData.vue?vue&type=template&id=04070cde&lang=pug"
import script from "./QuotationData.vue?vue&type=script&lang=js"
export * from "./QuotationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports